export const findIndexByName = (list, name) => {
    return list.findIndex((ele) => ele.name === name);
};

export const findNameByIndex = (list, index) => {
    if (index < 0 || index >= list.length) return '';
    return list[index].name;
};
